import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { SeoService } from '../core/services/seo.service';
import { NavigationComponent } from '../shared/navigation.component';
import { FooterComponent } from '../shared/footer.component';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, RouterModule, NavigationComponent, FooterComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {
  currentYear = new Date().getFullYear();
  lastUpdated = 'Abril 2026';

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.seoService.updateSEOData({
      keywords: 'política de privacidad, privacidad datos, protección información, GDPR, datos personales, Pezeta Solutions',
      structuredData: {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Política de Privacidad",
        "description": "Política de privacidad de Pezeta Solutions. Conoce cómo protegemos y manejamos tus datos personales.",
        "url": "https://chatbot.pezetasolutions.com/politicas-de-privacidad",
        "publisher": {
          "@type": "Organization",
          "name": "Pezeta Solutions",
          "logo": {
            "@type": "ImageObject",
            "url": "https://chatbot.pezetasolutions.com/images/gray-logo-80.webp"
          }
        },
        "dateModified": "2026-04-28",
        "inLanguage": "es-MX"
      }
    });

    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
  }
}
